<template>
  <div :class="[{ 'flipped ': flipped }]" class="w-full h-full flip-container relative">
    <div class="flipper h-full">
      <div class="front h-full">
        <slot name="front" class="h-full">
          <div class="h-full relative w-full">
            <div class="h-full w-full bg-white rounded-lg">
              <div class="rounded-md p-3 h-[calc(100%-200px)] w-full">
                <div class="w-full h-full flex items-center justify-center relative">
                  <img
                    v-if="$store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, 'N/A', $route))?.avatar"
                    class="inline-block rounded-full h-[80%] aspect-square object-cover"
                    :src="$store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, 'N/A', $route))?.avatar"
                    alt="">
                  <Avatar
                    v-else
                    :w="w"
                    :h="h"
                    radius="80%"
                    class=""
                    :hover-effect="true"
                    :first-name="
                      $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, 'N/A', $route))?.first_name
                    "
                    :last-name="
                      $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, 'N/A', $route))?.last_name
                    " />
                </div>
              </div>
              <div class="font-medium text-2xl text-center w-full mt-2">
                {{ $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, "N/A", $route))?.full_name }}
              </div>
              <div class="text-lg text-center w-full">
                {{ $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, "N/A", $route))?.job_title }}
              </div>
              <div
                class="absolute bottom-4 cursor-pointer z-10 text-center w-full dark:text-dark-brand-blue text-light-brand-blue"
                @click="flipped = true">
                {{ $t("Find out more about") }}
                {{ $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, "N/A", $route))?.full_name }}
              </div>
              <div class="flex items-center justify-center space-x-4 absolute bottom-16 w-full z-10">
                <a
                  v-if="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.facebook_profile
                  "
                  target="_blank"
                  :href="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.facebook_profile
                  ">
                  <FacebookIcon class="w-5 h-5 cursor-pointer" />
                </a>
                <a
                  v-if="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.twitter_profile
                  "
                  target="_blank"
                  :href="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.twitter_profile
                  ">
                  <Twitter class="w-5 h-5 cursor-pointer" color="#1da1f2" fill="#1da1f2" />
                </a>
                <a
                  v-if="$store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.phone_number"
                  target="_blank"
                  :href="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.phone_number
                  ">
                  <WhatsappIcon class="w-5 h-5 cursor-pointer" />
                </a>
                <a
                  v-if="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.linkedin_profile
                  "
                  target="_blank"
                  :href="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.linkedin_profile
                  ">
                  <Linkedin class="w-5 h-5 cursor-pointer" fill="#0077b5" color="#0077b5" />
                </a>
                <a
                  v-if="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.instagram_profile
                  "
                  target="_blank"
                  :href="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.instagram_profile
                  ">
                  <InstagramIcon class="w-5 h-5 cursor-pointer" />
                </a>
                <a
                  v-if="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.personal_website
                  "
                  target="_blank"
                  :href="
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, null, $route))?.personal_website
                  ">
                  <Globe class="w-5 h-5 cursor-pointer" />
                </a>
              </div>
            </div>
          </div>
        </slot>
      </div>
      <div class="back h-full">
        <slot name="back" class="h-full">
          <div class="h-full relative w-full">
            <div class="h-full w-full bg-white rounded-lg">
              <div class="font-medium text-2xl text-center w-full">
                <span class="relative top-5">{{
                  $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, "N/A", $route))?.full_name
                }}</span>
              </div>
              <div class="text-lg text-center w-full">
                <span class="relative top-5">
                  {{
                    $store.state.data.users.find((u) => u.id == $utils.extractValue(team_member_selected, "N/A", $route))?.job_title
                  }}</span>
              </div>
              <div class="p-5 relative top-5 h-[65%] overflow-auto" v-html="$utils.extractValue(more_details, 'N/A', $route)" />
              <div
                class="absolute bottom-4 cursor-pointer z-10 text-center w-full dark:text-dark-brand-blue text-light-brand-blue"
                @click="flipped = false">
                {{ $t("Close") }}
              </div>
            </div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import FacebookIcon from "@/components/shared/icons/FacebookIcon.vue"
import InstagramIcon from "@/components/shared/icons/InstagramIcon.vue"
import WhatsappIcon from "@/components/shared/icons/WhatsappIcon.vue"
import Avatar from "@/components/shared/Avatar.vue"
import { Twitter, Linkedin, Globe } from "lucide-vue-next"

export default {
  name: "TeamCardComponent",
  components: {
    FacebookIcon,
    Twitter,
    WhatsappIcon,
    Linkedin,
    InstagramIcon,
    Globe,
    Avatar
  },
  props: {
    team_member_selected: null,
    more_details: null,
    h: null,
    w: null
  },
  data() {
    return {
      flipped: false
    }
  }
}
</script>

<style type="text/css" scoped>
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
}
.flip-container {
  min-height: 120px;
}
.flipper {
  -moz-transform: perspective(1000px);
  -moz-transform-style: preserve-3d;
  transform: perspective(1000px);
  transform-style: preserve-3d;
  position: relative;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.8s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.8s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.8s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.8s;
  -ms-transform-style: preserve-3d;
  transition: 0.8s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.front {
  z-index: 2;
}
</style>
